import React from 'react'
import CarouselSlider from './CarouselSlider'
import AboutUs from './AboutUs'
import Subjects from './Subjects'
import SyllabusPage from './SyllabusPage'
import AllSubjects from './AllSubjects'
import Countries from './Countries'

const RootPage = () => {
  return (
    <>
   <CarouselSlider/>
   <AboutUs/>
   <AllSubjects/>
   <Subjects/>
   <Countries/>
   <SyllabusPage/>
   </>
  )
}

export default RootPage